import React, { Component } from 'react';
import { Col, message, Row, Table } from 'antd';

import util from '@util';
import { BackBtn } from '@comm/BackBtn';
import { queryDictExpend } from '@api/core/dict';
import { queryImportBudgetGroupSetInfo } from '@api/finance/budget';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      expendType: [],
    };
  }

  componentWillMount() {
    this.loadBudgetExpendType();
  }

  componentDidMount() {
    this.loadData();
  }

  loadBudgetExpendType = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  loadData = () => {
    this.setState({
      isLoading: true,
    });
    const pa = {};
    pa.groupUuid = this.props.params.uuid;
    pa.year = this.props.location.query.year;
    queryImportBudgetGroupSetInfo(pa).then(res => {
      if (res.statusCode === 200) {
        let data = [];
        data = data.concat(res.data.LABOR_COSTS);
        data = data.concat(res.data.BUSINESS_COSTS);
        data = data.concat(res.data.BUSINESS_POOL);
        data = data.concat(res.data.FIXED_POOL);

        res.data.SUM.flag = 5;
        if (data.length > 0) {
          data = data.concat(res.data.SUM);
        }
        this.setState({
          sum: res.data.SUM.SUM,
          data,
          isLoading: false,
          busCosLen: res.data.BUSINESS_COSTS.length,
          busPoolLen: res.data.BUSINESS_POOL.length,
          fixedLen: res.data.FIXED_POOL.length,
          laborLen: res.data.LABOR_COSTS.length,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    const config = [];
    const { data, busCosLen, busPoolLen, fixedLen, laborLen } = this.state;
    for (let i = 1; i <= 12; i++) {
      const item = {};
      const key = i < 10 ? `0${i}` : `${i}`;
      item.title = i < 10 ? `0${i}` : `${i}`;
      item.dataIndex = key;
      item.key = key;
      item.width = 100;
      item.render = text => {
        const money = util.numberFormat(text, 2, '.', ',');
        return <span>{money === '0.00' ? '' : money}</span>;
      };
      config.push(item);
    }
    config.unshift({
      title: '合计',
      dataIndex: 'sum',
      key: 'sum',
      width: 150,
      render: text => {
        const money = util.numberFormat(text, 2, '.', ',');
        return <span>{money === '0.00' ? '' : money}</span>;
      },
    });
    config.unshift({
      title: '费用科目',
      dataIndex: 'type',
      key: 'type',
      width: 150,
      render: (text, record, index) => {
        const obj = {
          children: <span>{this.matchType(text)}</span>,
          props: {},
        };
        if (index === data.length - 1) {
          obj.props.colSpan = 0;
        }
        return obj;
      },
    });
    config.unshift({
      title: '二级科目',
      dataIndex: 'sub',
      key: 'sub',
      width: 150,
      render: (text, record, index) => {
        let sub = '';
        if (record.flag === 1) {
          sub = '人力成本';
        } else if (record.flag === 2) {
          sub = '业务成本';
        } else if (record.flag === 3) {
          sub = '固定公摊';
        } else if (record.flag === 4) {
          sub = '业务公摊';
        } else if (record.flag === 5) {
          sub = '合计';
        }
        const obj = {
          children: <span>{sub}</span>,
          props: {},
        };
        if (laborLen !== 0 && index === 0) {
          obj.props.rowSpan = laborLen; // 合并业务公摊
        } else if (index > 0 && index < laborLen) {
          obj.props.rowSpan = 0;
        } else if (busCosLen !== 0 && index === laborLen) {
          obj.props.rowSpan = busCosLen; // 合并业务成本
        } else if (index > laborLen && index < laborLen + busCosLen) {
          obj.props.rowSpan = 0;
        } else if (fixedLen !== 0 && index === laborLen + busCosLen) {
          obj.props.rowSpan = fixedLen; // 合并固定公摊
        } else if (index > laborLen + busCosLen && index < laborLen + busCosLen + fixedLen) {
          obj.props.rowSpan = 0;
        } else if (busPoolLen !== 0 && index === fixedLen + busCosLen + laborLen) {
          obj.props.rowSpan = busPoolLen;
        } else if (
          index > busPoolLen + busCosLen + laborLen &&
          index < busPoolLen + busCosLen + fixedLen + laborLen
        ) {
          obj.props.rowSpan = 0;
        } else {
          obj.props.colSpan = 2;
        }
        return obj;
      },
    });
    config.unshift({
      title: '一级科目',
      dataIndex: 'main',
      key: 'main',
      width: 150,
      render: (text, record, index) => {
        const obj = {
          children: <span>运营成本</span>,
          props: {},
        };
        if (index === 0) {
          obj.props.rowSpan = data.length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    });
    return config;
  };

  matchType = value => {
    let type;
    this.state.expendType.map(item => {
      if (item.value === value) {
        type = item.key;
        return item;
      }
      return type;
    });
    return type;
  };

  render() {
    const { isLoading, data, sum } = this.state;
    return (
      <div>
        <Row>
          <BackBtn />
        </Row>
        <div>
          <Row>
            <Col span={1} />
            <Col span={8}>
              <span>预算部门：</span>
              <span>{this.props.location.query.groupName}</span>
            </Col>
            <Col span={12}>
              <span>预算周期：</span>
              <span>{this.props.location.query.year}年</span>
            </Col>
            <Col>
              <span>预算总额：</span>
              <span>{sum}元</span>
            </Col>
          </Row>
        </div>
        <div>
          <Table
            rowKey={record => record.index}
            columns={this.columns()}
            dataSource={data}
            pagination={false}
            loading={isLoading}
            style={{ paddingTop: '20px' }}
            bordered
            size="small"
            scroll={{ x: 1800, y: util.pageHeight() - 120 }}
          />
        </div>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/finance/budget/toview.js